import styled, { keyframes } from 'styled-components';
import { useMemo } from 'react';

const glow = keyframes`
  0%, 100% {
    opacity: 0.3;
    filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.3));
  }
  50% {
    opacity: 0.8;
    filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.6)) drop-shadow(0 0 6px rgba(255, 255, 255, 0.4));
  }
`;

const SparklesContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
`;

const Sparkle = styled.div`
  position: absolute;
  animation: ${glow} ${props => props.$duration}s ease-in-out infinite;
  animation-delay: ${props => props.$delay}s;

  svg {
    display: block;
  }
`;

export const Sparkles = ({ count = 50 }) => {
  const sparkles = useMemo(() => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      top: `${Math.random() * 100}%`,
      left: `${Math.random() * 100}%`,
      duration: 1.5 + Math.random() * 2,
      delay: Math.random() * 3,
      scale: 0.5 + Math.random() * 0.8
    }));
  }, [count]);

  return (
    <SparklesContainer>
      {sparkles.map(sparkle => (
        <Sparkle
          key={sparkle.id}
          style={{
            top: sparkle.top,
            left: sparkle.left,
            transform: `translate(-50%, -50%) scale(${sparkle.scale})`
          }}
          $duration={sparkle.duration}
          $delay={sparkle.delay}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path opacity="0.96" d="M10.349 18.7293L7.58698 11.56L9.43107e-05 10.3489L7.16939 7.58688L8.38046 -8.44318e-06L11.1425 7.16929L18.7294 8.38036L11.5601 11.1424L10.349 18.7293Z" fill="white"/>
          </svg>
        </Sparkle>
      ))}
    </SparklesContainer>
  );
};
